import React from "react";

const InputItemList = ({ keyvalue = {} }) => {
  return (
    <>
      <input type="text" defaultValue={keyvalue.key} /> ={" "}
      <input type="text" defaultValue={keyvalue.value} />
    </>
  );
};

const InputList = ({ title, items = [] }) => {
  return (
    <div>
      <label>{title}</label>
      {items.map((item, index) => (
        <InputItemList key={index} keyvalue={item}></InputItemList>
      ))}
      <InputItemList></InputItemList>
    </div>
  );
};

export default InputList;
